import React from 'react'
import { Link } from 'react-router-dom'
import IkonaAsystenta from '../ikony/IkonaAsystenta'
import { jestPolska } from '../../kraj'

/**
 * Wejście do asystenta doboru, wpięte w PASEK NAGŁÓWKA listingu — obok
 * przełącznika widoku, a nie jako osobny pas nad listą.
 *
 * Miejsce jest celowe: pasek nagłówka zostaje na ekranie razem z listą, więc
 * przycisk widzi także ktoś, kto zaczął już przeglądać i dopiero po kilku
 * pozycjach zorientował się, że nie umie wybrać. Pas nad listingiem znikał po
 * pierwszym przewinięciu, czyli dokładnie wtedy, gdy stawał się potrzebny.
 *
 * Dwa wiersze, bo mówią o dwóch różnych rzeczach: pierwszy o korzyści dla
 * użytkownika, drugi nazywa narzędzie. Nazwa narzędzia kursywą, żeby nie
 * konkurowała z obietnicą.
 */
const PrzyciskAsystenta = ({ to, tytul, narzedzie = 'Asystent doboru' }) => (
  // Asystenci pojedynczych komponentów są jeszcze tylko po polsku.
  !jestPolska ? null : <Link
    to={to}
    className="inline-flex items-center gap-2.5 px-4 py-2 rounded-xl bg-blue-600 hover:bg-blue-500
               active:bg-blue-700 text-white no-underline transition-colors shadow-sm
               focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
  >
    <IkonaAsystenta className="w-5 h-5 flex-shrink-0" />
    <span className="text-left leading-tight">
      <span className="block text-sm font-semibold">{tytul}</span>
      <span className="block text-[11px] italic text-blue-100">{narzedzie}</span>
    </span>
  </Link>
)

export default PrzyciskAsystenta
